// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"491":"89e3e769","504":"7c8c36a5"}[chunkId] + ".chunk.css";
};